<template>
  <b-row class="justify-content-center">
    <b-col md="8">
      <div class="form-card">
        <!-- Section Header -->
        <h2 class="form-title">Add User</h2>
        <p class="form-subtitle">Add a new user and give them role</p>

        <b-form @submit.prevent="handleSubmit">
          <!-- Name Input -->
          <b-form-group label="Name" label-for="name" class="form-group">
            <b-form-input
              id="name"
              v-model="form.name"
              required
              placeholder="Enter a name for new user"
              class="form-input"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            label="Username"
            label-for="username"
            class="form-group"
          >
            <b-form-input
              id="username"
              v-model="form.username"
              required
              placeholder="Enter a username for new user"
              class="form-input"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Email" label-for="email" class="form-group">
            <b-form-input
              id="email"
              v-model="form.email"
              required
              type="email"
              placeholder="Enter a email for new user"
              class="form-input"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="Password"
            label-for="password"
            class="form-group"
          >
            <b-form-input
              id="password"
              v-model="form.password"
              required
              type="password"
              placeholder="Enter Password"
              class="form-input"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="Password"
            label-for="password"
            class="form-group"
          >
            <b-form-input
              id="confirmPassword"
              v-model="form.confirmPassword"
              required
              type="password"
              placeholder="Enter Password Again"
              class="form-input"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Role" label-for="role" class="form-group mt-4">
            <b-form-select
              id="role"
              v-model="form.role"
              :options="[
                {
                  text: 'Root',
                  value: 0,
                },
                {
                  text: 'Admin',
                  value: 1,
                },
              ]"
              class="form-select"
            >
            </b-form-select>
          </b-form-group>

          <b-button
            type="submit"
            variant="primary"
            class="w-100 mt-4 action-btn"
            :disabled="submitting"
          >
            {{ submitting ? "Please Wait..." : "Submit" }}
          </b-button>
        </b-form>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      form: {
        name: "",
        username: "",
        email: "",
        password: "",
        confirmPassword: "",
        role: 1,
      },
      submitting: false,
    };
  },
  methods: {
    async handleSubmit() {
      try {
        this.submitting = true;

        if (this.form.password !== this.form.confirmPassword) {
          this.$toast.error("Passwords do not match!");
          this.submitting = false;
          return;
        }

        const resposne = await axios.post("api/users/new", { ...this.form });
        if (resposne.data.success) {
          this.$toast.success("User has been created succsesfully!");
          this.$router.push("/users/all");
        }
      } catch (e) {
        this.$toast.error("Error occured!");
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
/* General Styling */
.form-container {
  background-color: #f9fafb;
  padding: 40px;
  border-radius: 12px;
}

.form-card {
  background: white;
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

/* Typography */
.form-title {
  font-size: 22px;
  font-weight: 600;
  color: #111827;
}

.form-subtitle {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 20px;
}

/* Input Fields */
.form-group {
  margin-bottom: 20px;
}

.form-input,
.form-select,
.form-file {
  width: 100%;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  padding: 10px;
  font-size: 14px;
  background-color: white;
  transition: border 0.2s ease-in-out;
}

.form-input:focus,
.form-select:focus,
.form-file:focus {
  border-color: #0077ff;
  box-shadow: 0 0 4px rgba(99, 102, 241, 0.2);
}

/* Proxy Section */
.proxy-section {
  background: #f3f4f6;
  padding: 20px;
  border-radius: 8px;
  margin-top: 20px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 10px;
}

/* Buttons */
.action-btn {
  background-color: #0077ff;
  color: white;
  font-size: 16px;
  padding: 12px;
  border-radius: 8px;
  transition: all 0.2s ease-in-out;
}

.action-btn:hover {
  background-color: #4f46e5;
}

.submit-btn {
  background-color: #22c55e;
  color: white;
  font-size: 16px;
  padding: 12px;
  border-radius: 8px;
  transition: all 0.2s ease-in-out;
}

.submit-btn:hover {
  background-color: #16a34a;
}

@media (max-width: 768px) {
  .form-container {
    padding: 20px;
  }
}
</style>
